import type { BookingProposalDriversGetApiData, BookingProposalDriversGetApiResponses } from '@navio/nsdk';
import { apiUrl, dataEndpoint } from '../defineResource';

export const proposalUrls = {
  getBookingProposalDrivers: dataEndpoint<BookingProposalDriversGetApiData, BookingProposalDriversGetApiResponses>({
    getUrl: ({ slug }) => apiUrl(`booking-proposals/${slug}/drivers/`)
  })
};
